export const defaultLightList = [
    {
        metadata: {
            version: 4.5,
            type: 'Object',
            generator: 'Object3D.toJSON'
        },
        object: {
            uuid: '1FD70C22-BD3F-47A2-91A3-98317A33E073',
            type: 'AmbientLight',
            layers: 1,
            matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
            color: 16777215,
            intensity: 1
        }
    },
    {
        metadata: {
            version: 4.5,
            type: 'Object',
            generator: 'Object3D.toJSON'
        },
        object: {
            uuid: '647E677B-0072-4F42-8EA6-A117FA2F11D5',
            type: 'DirectionalLight',
            castShadow: true,
            layers: 1,
            matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 10, 15, 10, 1],
            color: 16777215,
            intensity: 0.6,
            shadow: {
                camera: {
                    uuid: '9CEAD0F3-F8C5-46BA-9438-C0D465FDFC18',
                    type: 'OrthographicCamera',
                    layers: 1,
                    zoom: 1,
                    left: -5,
                    right: 5,
                    top: 5,
                    bottom: -5,
                    near: 0.5,
                    far: 500
                }
            }
        }
    },
    {
        metadata: {
            version: 4.5,
            type: 'Object',
            generator: 'Object3D.toJSON'
        },
        object: {
            uuid: '82D42A88-A72D-46BA-80A4-7A757FBCEAEC',
            type: 'DirectionalLight',
            layers: 1,
            matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -10, 15, -10, 1],
            color: 16777215,
            intensity: 0.6,
            shadow: {
                camera: {
                    uuid: 'F18A3C2C-9D1E-4D84-BCD2-5811DB0D425A',
                    type: 'OrthographicCamera',
                    layers: 1,
                    zoom: 1,
                    left: -5,
                    right: 5,
                    top: 5,
                    bottom: -5,
                    near: 0.5,
                    far: 500
                }
            }
        }
    }
];
